import { DynamicFormModule } from './auth-content/dynamic-form/dynamic-form.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth/auth.component';
import { AuthRouting } from './auth-routing.module';
import { LoginComponent } from './auth-content/login/login.component';
import { ResetPasswordComponent } from './auth-content/reset-password/reset-password.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DynamicLoginComponent } from './auth-content/dynamic-login/dynamic-login.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { ForgotPasswordComponent } from './auth-content/forgot-password/forgot-password.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RxButtonModule } from '@nrwl/rx-button';
import { AdsBannerComponent } from './ads-banner/ads-banner.component';
//import { SwiperModule } from 'swiper';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthRouting,
    MatProgressBarModule,
    MatButtonModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DynamicFormModule,
    RxIconModule,
    RxButtonModule,
    MatTooltipModule,
    AuthComponent,
    LoginComponent,
    ResetPasswordComponent,
    DynamicLoginComponent,
    ForgotPasswordComponent,
    AdsBannerComponent,
    //        SwiperModule,
  ],
})
export class AuthModule {}
